import type React from 'react';

export enum PrefundStatus {
  PaymentInitiated = 'Payment initiated',
  PaymentRequested = 'Payment requested',
  PaymentRejected = 'Payment rejected',
  Paid = 'Paid',
  PaymentFailed = 'Payment failed',
  Reopen = 'Reopen',
  ActionRequired = 'Action required',
  Canceled = 'Canceled',
}

export enum PrefundReturnStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
  COMPLETED = 'COMPLETED',
  APPROVED = 'APPROVED',
}

export type InfoTableValue = {
  title: string;
  value?: string;
  isStatus?: boolean;
  styles?: React.CSSProperties;
  isAmount?: boolean;
};
